import { useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSecurity } from './Security/security';
import { StoreContext } from './Store';

const Logout = () => {
  const navigate = useNavigate();
  const { dispatch } = useSecurity();
  const store = useContext(StoreContext);
  useEffect(() => {
    dispatch({ type: 'logout' });
    //used to reset the dropdown selected value in useraddmin
    store?.resetUserIdSelected();
    navigate('/');
  }, [navigate, dispatch]);

  return null;
};

export default Logout;
